module.exports = __webpack_public_path__ + "static/media/stargold_7g.9ef11427.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/climasense/barrenador_pinha/curativa/stargold_7g.png
// module id = 2291
// module chunks = 3